// eslint-disable-next-line no-restricted-imports -- Required for Node.js script compatibility (routesMetadata.config.js)
import { TABLE_COLUMN_DEFINITIONS } from './table-cell.const.js'

/** Canonical ID sent to backend for custom company/product. */
export const TICKET_CUSTOM_ID_NEW = 'new'
/** UI-only custom entry ID; backend receives TICKET_CUSTOM_ID_NEW. */
export const TICKET_CUSTOM_ID_CUSTOM = 'custom'
/** IDs that represent custom/new company or product (not from directory). Use for checks like TICKET_CUSTOM_IDS.includes(companyId). */
export const TICKET_CUSTOM_IDS = [TICKET_CUSTOM_ID_NEW, TICKET_CUSTOM_ID_CUSTOM]

export const TICKET_CREATION_STEP_NAMES = {
  PRODUCT_SEARCH: 'product',
  REQUEST_DETAILS: 'qa',
  COMPLETED: 'complete',
}

export const TICKET_CREATION_STEPS = [
  {
    name: TICKET_CREATION_STEP_NAMES.PRODUCT_SEARCH,
    label: 'Find',
  },
  {
    name: TICKET_CREATION_STEP_NAMES.REQUEST_DETAILS,
    label: 'Explain',
  },
  {
    name: TICKET_CREATION_STEP_NAMES.COMPLETED,
    label: 'Submit',
  },
]

export const SEARCH_TAB_NAMES = {
  PRODUCTS: 'products',
  COMPANIES: 'companies',
  CUSTOM: 'custom',
}

export const COMPANY_VIEW_MODE = {
  LIST: 'list',
  PRODUCTS: 'products',
}

export const TRIGGER_KEYS = {
  SEARCH_HIGHLIGHT: 'searchHighlight',
}

export const SEARCH_TABS = [
  {
    name: SEARCH_TAB_NAMES.PRODUCTS,
    label: 'Product',
    icon: 'package',
  },
  {
    name: SEARCH_TAB_NAMES.COMPANIES,
    label: 'Company',
    icon: 'building',
  },
  {
    name: SEARCH_TAB_NAMES.CUSTOM,
    label: 'Custom Entry',
    icon: 'plus-circle',
  },
]

export const EMPTY_TICKET = {
  companyName: '',
  companyId: '',
  companyWebsite: '',
  productName: '',
  productId: '',
  productWebsite: '',
  answers: {},
  ticketId: '',
  uploadedFiles: [],
}

export const STEP_STATUS = {
  COMPLETE: 'complete',
  ACTIVE: 'active',
  DISABLED: 'disabled',
  READY: 'ready',
}

export const BADGE_STATES = {
  complete: {
    color: 'positive',
    label: 'Complete',
    icon: 'check-circle',
    textColor: 'surface',
  },
  active: {
    color: 'cta',
    label: 'In Progress',
    icon: 'circle-dot',
    textColor: 'primary',
  },
  disabled: {
    color: 'info',
    label: 'Locked',
    icon: 'lock',
    textColor: 'primary',
  },
  ready: {
    color: 'info',
    label: 'Ready',
    icon: null,
    textColor: 'surface',
  },
}

export const REQUEST_DETAILS_TABS = [
  {
    id: 'questions',
    label: 'Request Details',
    icon: 'help-circle',
  },
  {
    id: 'attachments',
    label: 'Request Attachments',
    icon: 'file-text',
  },
]

// Yes/No question options
export const YES_NO_OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
]

// Company results table columns
export const COMPANY_RESULTS_COLUMNS = [
  TABLE_COLUMN_DEFINITIONS.company,
  TABLE_COLUMN_DEFINITIONS.numberOfProducts,
  TABLE_COLUMN_DEFINITIONS.link,
  TABLE_COLUMN_DEFINITIONS.score,
]

// Product results table columns
export const PRODUCT_RESULTS_COLUMNS = [
  TABLE_COLUMN_DEFINITIONS.product,
  TABLE_COLUMN_DEFINITIONS.link,
  TABLE_COLUMN_DEFINITIONS.score,
]

// Company products table columns (single column)
export const COMPANY_PRODUCTS_COLUMNS = [TABLE_COLUMN_DEFINITIONS.title]

// Route parameter values for ticket edit steps
// These match TICKET_CREATION_STEP_NAMES values for consistency
export const TICKET_EDIT_STEPS = {
  PRODUCT: TICKET_CREATION_STEP_NAMES.PRODUCT_SEARCH,
  REQUEST_DETAILS: TICKET_CREATION_STEP_NAMES.REQUEST_DETAILS,
  COMPLETE: TICKET_CREATION_STEP_NAMES.COMPLETED,
}

// Default table state for product/company search results tables
export const DEFAULT_SEARCH_TABLE_STATE = {
  page: 1,
  rowsPerPage: 10,
}
